import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'updateSKUPositionDrawer.title',
    defaultMessage: 'Add SKU to preferred position',
    description: 'Title of the update sku position drawer',
  },
  feedback: {
    skuPositionUpdated: {
      id: 'updateSKUPositionDrawer.feedback.skuPositionUpdated',
      defaultMessage: 'Product position updated',
      description: 'Success message of updating the sku position',
    },
    skuPositionNotUpdated: {
      id: 'updateSKUPositionDrawer.feedback.skuPositionNotUpdated',
      defaultMessage: 'Product position not updated',
      description: 'error message of updating the sku position',
    },
  },
};

export default defineMessages(translations);
